<template>
  <div>
    <v-layout row wrap mt-4>
      <v-flex xs12 sm4 md1 text-xs-right class="hidden-xs-only">
        <image-app class="animated fadeInLeft" :imaSize="100" imaSrc="design/gray-arrow" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm6 md6 class="animated fadeInUp">
        <ui-title-one titleAccess="Todas las Metas deben ser" titleLevel="h1">
          <template slot="partOne">Todas las metas<br></template>
          <template slot="partTwo"></template>
          <template slot="partThree"> deben ser:</template>
        </ui-title-one>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'Todas las metas deben ser'" videoEmbed="ADMINISTRACIONDINERO05LasMetasDebenSer.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm8 class="animated fadeIn">
        <p>
          <strong>Haga clic sobre cada característica:</strong>
        </p>
      </v-flex>
    </v-layout>

    <!-- Componente contenidos de botones slide -->
    <ui-botsacronimos :bots="bots" nombreLista="Tipos de crédito" class="text-xs-center">
      <div v-for="(item, index) in bots" :key="'content'+index" :slot="'cont-'+index" class="animated fadeInRight">
        <ui-title-one :titleAccess="item.cont[0] + item.cont[1] + item.cont[2]" titleLevel="p">
          <template slot="partOne">{{item.cont[0]}}<br></template>
          <template slot="partTwo">{{item.cont[1]}}</template>
          <template slot="partThree">{{item.cont[2]}}</template>
        </ui-title-one>
      </div>
    </ui-botsacronimos>
    <!-- Fin de componente -->
    <v-flex>
      <p class="mt-4">Si quiere saber más acerca de la forma de establecer las <strong>METAS</strong> en el curso El Ahorro encontrará la <strong>Guía para Alcanzar las Metas</strong></p>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      contenido: 0,
      bots: [
        {
          name: "Medibles",
          nameDesing: "<span class='font-red'>M</span>edibles",
          cont: ["¿Cuánto debo ahorrar ", "para ", "alcanzar la meta?"],
          visto: false
        },
        {
          name: "Específicas",
          nameDesing: "<span class='font-red'>E</span class='font-red'>specíficas",
          cont: ["¿Cuál es la meta", " que quiero", " alcanzar?"],
          visto: false
        },
        {
          name: "Temporales",
          nameDesing: "<span class='font-red'>T</span class='font-red'>emporales",
          cont: ["¿Cuándo quiero", "alcanzar", " la meta?"],
          visto: false
        },
        {
          name: "Alcanzables",
          nameDesing: "<span class='font-red'>A</span class='font-red'>lcanzables",
          cont: ["¿Está dentro de ", "las ", "posibilidades?"],
          visto: false
        },
        {
          name: "Significativas",
          nameDesing: "<span class='font-red'>S</span class='font-red'>ignificativas",
          cont: ["¿La meta es ", "verdaderamente ", "importante?"],
          visto: false
        }
      ]
    };
  },
  mounted() {
    this.$store.commit("nextShow", false);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-05.vue?701810ee